
const intervalIdSalepify = setInterval(() => {
    if (window.tlFreeGiftOffer) {
        document.addEventListener('submit', function (e) {
        const form = e.target;

        // Chỉ xử lý form cart / checkout
        if (
            form.tagName === 'FORM' &&
            (
            form.getAttribute('action') === '/cart' ||
            form.getAttribute('action')?.startsWith('/checkout')
            )
        ) {
            const discountInput = form.querySelector('input[name="discount"]');

            if (discountInput && !discountInput.value.trim()) {
            discountInput.disabled = true;
            }
        }
        });

        console.log("Custom salepify done");
    }
}, 100);

setTimeout(() => {
    clearInterval(intervalIdSalepify);
}, 3000)